import { useEffect } from 'react';

const SITE_URL = 'https://ajantasirsa.com';

function ensureMeta(selector, attrs = {}) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    Object.keys(attrs).forEach(k => el.setAttribute(k, attrs[k]));
    document.head.appendChild(el);
  }
  return el;
}

export default function SEO({ title, description, path = '/', image }) {
  useEffect(() => {
    const normalizedPath = path === '/' ? '/' : `/${path.replace(/^\/+|\/+$/g, '')}`;
    const canonicalUrl = `${SITE_URL}${normalizedPath}`;
    if (title) document.title = title;

    // description
    const descEl = ensureMeta('meta[name="description"]', { name: 'description' });
    if (description) descEl.setAttribute('content', description);

    // Open Graph
    const ogTitle = ensureMeta('meta[property="og:title"]', { property: 'og:title' });
    if (title) ogTitle.setAttribute('content', title);
    const ogDesc = ensureMeta('meta[property="og:description"]', { property: 'og:description' });
    if (description) ogDesc.setAttribute('content', description);
    const ogUrl = ensureMeta('meta[property="og:url"]', { property: 'og:url' });
    ogUrl.setAttribute('content', canonicalUrl);
    const ogImage = ensureMeta('meta[property="og:image"]', { property: 'og:image' });
    ogImage.setAttribute('content', image || `${SITE_URL}/og-image.png`);

    // Twitter cards
    const twCard = ensureMeta('meta[name="twitter:card"]', { name: 'twitter:card' });
    twCard.setAttribute('content', 'summary_large_image');
    const twTitle = ensureMeta('meta[name="twitter:title"]', { name: 'twitter:title' });
    if (title) twTitle.setAttribute('content', title);
    const twDesc = ensureMeta('meta[name="twitter:description"]', { name: 'twitter:description' });
    if (description) twDesc.setAttribute('content', description);
    const twImage = ensureMeta('meta[name="twitter:image"]', { name: 'twitter:image' });
    twImage.setAttribute('content', image || `${SITE_URL}/og-image.png`);

    // canonical
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalUrl);
  }, [description, path, title, image]);

  return null;
}